module.exports = __webpack_public_path__ + "img/product14.c0aaeaef.jpg";